import { FC, useState } from "react"
import styled from "styled-components"
import { OptionButton } from "../atoms"
import { DropdownMenu } from "./DropDownMenu"

type OptionProps = {
  item: string
  action: () => void
}

type ButtonWithDropDownMenuProps = {
  options: OptionProps[],
  position: 'top' | 'bottom' | 'left' | 'right'
}

const DropDownMenuWrapper = styled.div`
  position: relative;
`
export const ButtonWithDropDownMenu: FC<ButtonWithDropDownMenuProps> = ({ options, position }) => {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <DropDownMenuWrapper>
      <OptionButton onClick={() => setIsOpen(true)} tooltipText="menu opcional"/>
      <DropdownMenu
        isOpen={isOpen}
        onOutsideClickAction={() => setIsOpen(false)}
        options={options}
        position={position}
      />
    </DropDownMenuWrapper>
  )
} 